"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PenOptionsBase = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
class PenOptionsBase {
    constructor() {
        this.type = bridge_schema_1.ToolType.Pen2D;
        this.size = 3;
        this.color = '229,51,157';
        this.opacity = 1;
    }
}
exports.PenOptionsBase = PenOptionsBase;
